<template>
    <div>
        <div>
            <h2 class="text-lg leading-6 font-semibold text-gray-900 ">
                {{ title }}
            </h2>
            <div class="flex-grow border-t border-gray-200 my-3"></div>
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped></style>
